import React from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { TbUserFilled } from "react-icons/tb";
import { MdPayment } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';

const Togglebar = () => {
    const location = useLocation();

    const getActiveMenuItem = (path) => {
        if (path.includes('/subscription')) return 'Subscriptions';
        if (path.includes('/account')) return 'Account';
        return '';
    };

    const activeMenuItem = getActiveMenuItem(location.pathname);

    const tabs = [
        { label: 'Account', to: '/account', icon: <TbUserFilled size={18} /> },
        { label: 'Subscriptions', to: '/subscriptions', icon: <MdPayment size={18} /> },
    ];

    return (
        <nav
            role="tablist"
            aria-label="Main Navigation Tabs"
            className="w-[70%] mx-auto flex bg-white  rounded-full shadow relative z-0"
        >
            {tabs.map(({ label, to, icon }, idx) => {
                const isActive = activeMenuItem === label;
                const isFirst = idx === 0;
                const isLast = idx === tabs.length - 1;

                return (
                    <Link
                        key={label}
                        to={to}
                        role="tab"
                        aria-selected={isActive}
                        className={`flex-1 transition-all duration-300 relative z-10 
                        `}
                    >
                        <div
                            className={`flex items-center justify-center gap-2 py-3 px-4 w-full h-full 
                                ${
                                    isActive
                                        ? 'bg-blue-100 text-blue-600 z-20 w-[120%]'
                                        : 'bg-white text-gray-700 hover:bg-gray-100 z-10'
                                }
                                ${
                                    isFirst
                                        ? 'rounded-full'
                                        : isLast
                                        ? 'rounded-full'
                                        : ''
                                }
                                transition-all duration-300 border border-white`}
                        >
                            <span className="hidden sm:block ">{icon}</span>
                            <span className="text-xs font-medium">{label}</span>
                        </div>
                    </Link>
                );
            })}
        </nav>
    );
};

export default Togglebar;
